import { connect } from 'react-redux'
import * as selector from '../../state/instance-detail/selector'
import StateTransitionLog from '../instance-detail/StateTransitionLog'

const mapStateToProps = (state, props) => {
    return {
        processStateHistoryList: selector.selectProcessStateHistoryList(state),
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(StateTransitionLog)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/StateTransitionLogContainer.js